var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUpdate = function SvgUpdate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 7.667a.833.833 0 0 0-.833.833 6.709 6.709 0 1 1-1.85-4.583h-2a.833.833 0 0 0 0 1.666h3.775a.833.833 0 0 0 .833-.833V1a.834.834 0 0 0-1.666 0v1.475A8.334 8.334 0 1 0 17.334 8.5a.833.833 0 0 0-.834-.833Z"
  })));
};
export default SvgUpdate;